import axios from "axios";

import { API_BASE_URL } from "../constants";

const getControllerState = async () => {
    const { data: {running: state }  } = await axios.get(`${API_BASE_URL}/controllers`)
    return state;
}

const setState = async (state: boolean) => {
    await axios.put(`${API_BASE_URL}/controllers`, { running: state });
}

const controllerService = { getControllerState, setState };

export default controllerService;